import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgBuilding(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.9713 2.25266C12.3672 1.91708 11.6328 1.91708 11.0287 2.25266L2.77154 6.83998C2.29534 7.10454 2 7.60647 2 8.15122V9.35702C2 10.1854 2.67157 10.857 3.5 10.857H5V17.001H3C2.44772 17.001 2 17.4487 2 18.001C2 18.5533 2.44772 19.001 3 19.001H21C21.5523 19.001 22 18.5533 22 18.001C22 17.4487 21.5523 17.001 21 17.001H19V10.857H20.5C21.3284 10.857 22 10.1854 22 9.35702V8.15122C22 7.60647 21.7047 7.10454 21.2285 6.83998L12.9713 2.25266ZM9 17.001H7V10.857H9V17.001ZM13 17.001H11V10.857H13V17.001ZM17 17.001H15V10.857H17V17.001Z", fill: "currentColor" }),
        React.createElement("path", { d: "M3 20.001C2.44772 20.001 2 20.4487 2 21.001C2 21.5533 2.44772 22.001 3 22.001H21C21.5523 22.001 22 21.5533 22 21.001C22 20.4487 21.5523 20.001 21 20.001H3Z", fill: "currentColor" })));
}
export default SvgBuilding;
